import 'swiper/css';
import 'swiper/css/scrollbar';

import React from 'react';
import { isEmpty } from 'lodash';
import { Scrollbar } from 'swiper';
import Image from 'next/future/image';
import { Swiper, SwiperSlide } from 'swiper/react';

import { IProduct } from '@/models';
import { useTranslation } from 'react-i18next';
import { getAllMaterials } from '@/fetchers/materials';

interface Props {
  product: IProduct;
}

const Materials: React.FC<Props> = ({ product }) => {
  const { t } = useTranslation();

  if (isEmpty(product.materials)) {
    return null;
  }

  const materials = product.materials;
  const allMaterials = getAllMaterials();

  return (
    <section className="section full space-y-md">
      <div className="h3 text-center">{t('P_PDP.MATERIALS.TITLE')}</div>

      <Swiper
        wrapperTag="ul"
        slidesPerView={materials.length > 1 ? 1.2 : 1}
        spaceBetween={10}
        modules={[Scrollbar]}
        scrollbar={{ hide: false }}
        className="swiperScrollbar px-6 md:px-10 xl:px-16"
        breakpoints={{
          768: {
            slidesPerView: materials.length > 1 ? 1.5 : 1
          },
          1024: {
            slidesPerView: materials.length > 2 ? 2.5 : materials.length
          }
        }}
      >
        {materials.map(material => {
          const materialIcon = allMaterials[material.code]?.icon;

          return (
            <SwiperSlide
              key={material.name}
              tag="li"
              className="relative rounded-lg overflow-hidden"
            >
              <div className="absolute inset-0 bg-black/40" />

              <div className="space-y-6">
                {material.image && (
                  <Image
                    src={material.image}
                    alt={material.name}
                    width={0}
                    height={0}
                    sizes="100vw"
                    className="h-[650px] w-full object-cover object-center"
                  />
                )}

                <div className="absolute inset-0">
                  <div className="h-full max-w-xl mx-auto flex flex-col justify-center text-white space-y-3 px-6 md:px-10 xl:px-16">
                    {materialIcon && (
                      <Image
                        src={materialIcon}
                        alt={material.name}
                        width={0}
                        height={0}
                        sizes="100vw"
                        className="max-w-[75px] w-full h-auto object-contain md:max-w-[100px]"
                      />
                    )}

                    {material.title && (
                      <div className="h5 font-extrabold">{material.title}</div>
                    )}

                    <span className="font-medium uppercase text-lg">
                      {material.name}
                    </span>

                    <p className="text-sm line-clamp-5">
                      {material.description}
                    </p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </section>
  );
};

export default Materials;
